// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { makeDate, makeDateNow, makeUnixDate, checkSameDate } from "src/lib/utils.js";

// Stateful components

export class UniversityEvents extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "todays_events": [],
            "upcoming_events": [],
            "current_upcoming_events": [],
            "events_per_page": 5,
            "current_page": 1,
            "total_pages": 1,
            "enable_pagination": true
        };
        

        // Binds
        this.processEventsData = this.processEventsData.bind(this);
        this.compareEventData = this.compareEventData.bind(this);
        this.renderDescription = this.renderDescription.bind(this);
        this.previousPaginationClick = this.previousPaginationClick.bind(this);
        this.nextPaginationClick = this.nextPaginationClick.bind(this);
    }


    //
    // Functions
    //

    componentDidMount() {
        var this_component = this;
        var events_data = this_component['props']['data'];
        
        this_component.processEventsData(events_data);

    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;

        // Events data
        var event_data = this_component['props']['data'];
        if(JSON.stringify(event_data) !== JSON.stringify(prev_props['data'])) {
            this_component.processEventsData(event_data);
        }
    }

    compareEventData( a, b ) {
        if ( makeUnixDate(a['event_startdate']) < makeUnixDate(b['event_startdate']) ){
          return -1;
        }
        if ( makeUnixDate(a['event_startdate']) > makeUnixDate(b['event_startdate']) ){
          return 1;
        }
        return 0;
    }
    
    processEventsData(events_data){
        var this_component = this;
        var portal_context = this_component['context'];
        var all_events = [];
        var todays_events = [];
        var upcoming_events = [];
        var today = makeDateNow();
        var user_personalisation = portal_context['user_personalisation'];
        var campus_maps_data = portal_context['configuration']['campus_maps'];

        // merge all events into one object so we can sort them
        for(var key in events_data){
            all_events = [...all_events, ...events_data[key]]
        }

       // var sorted_events = all_events.sort(this_component.compareEventData);

        for(var index = 0; index < all_events.length; index++){
            var this_date = makeUnixDate(all_events[index]['event_startdate']);
            all_events[index]['event_day'] = this_date.format('D');
            all_events[index]['event_month'] = this_date.format('MMM');
            all_events[index]['event_year'] = this_date.format('YYYY');

            var this_campus = all_events[index]['event_campus'].toLowerCase().replace(/ /g, '_').replace('_campus', '').split(',')[0];
            if (typeof campus_maps_data[this_campus] != 'undefined') {
                all_events[index]['campus_map_url'] = campus_maps_data[this_campus];
            }

            // if event is on today
            if(checkSameDate(this_date, today)) {
                todays_events.push(all_events[index]);
            } else {
                // else - upcoming events
                if(!this_date.isBefore(makeDateNow(), 'day')){
                    upcoming_events.push(all_events[index]);
                }
            }
        }

        // sort upcoming events
        upcoming_events = upcoming_events.sort(this_component.compareEventData);
        upcoming_events = sq_personalise.fn.filterItems(upcoming_events, user_personalisation['attributes']);


        var events_per_page = this_component['state']['events_per_page'];
        var pages_required = Math.ceil(upcoming_events.length / events_per_page);
        var pagination_required = upcoming_events.length > events_per_page;
        
        this_component.setState({
            "todays_events": todays_events,
            "upcoming_events": upcoming_events,
            "current_upcoming_events": upcoming_events.slice(0, events_per_page),
            "total_pages": pages_required,
            "enable_pagination": pagination_required
        });

    }

    previousPaginationClick(event){
        event.preventDefault();

        var this_component = this;
        var events_per_page = this_component['state']['events_per_page'];
        var current_page = this_component['state']['current_page'];
        var all_upcoming_events = this_component['state']['upcoming_events'];

        var pager_from = ((current_page - 1) * events_per_page) - events_per_page;
        var pager_to = pager_from + events_per_page;

        this_component.setState({
            "current_upcoming_events": all_upcoming_events.slice(pager_from, pager_to),
            "current_page": current_page - 1
        });
    }
    nextPaginationClick(event){
        event.preventDefault();
        var this_component = this;

        var this_component = this;
        var events_per_page = this_component['state']['events_per_page'];
        var current_page = this_component['state']['current_page'];
        var all_upcoming_events = this_component['state']['upcoming_events'];

        var pager_from = current_page * events_per_page;
        var pager_to = pager_from + events_per_page;

        this_component.setState({
            "current_upcoming_events": all_upcoming_events.slice(pager_from, pager_to),
            "current_page": current_page + 1
        });
    }

    renderDescription(content) {
        return {__html: content};
    }
    
    //
    // Render
    //

    render() {
        var this_component = this;
        var portal_context = this_component['context'];

        var no_data_message = portal_context['configuration']['system_messages']['nodata']['events'];

        var todays_events = this_component['state']['todays_events'];
        var current_upcoming_events = this_component['state']['current_upcoming_events'];
        var use_pagination = this_component['state']['enable_pagination'];
        var current_page = this_component['state']['current_page'];
        var total_pages = this_component['state']['total_pages'];

        return (
            <div className="schedule__main">
                <ContextualMessage id="university_events" />
                <span className="schedule__heading">Today</span>
                {todays_events.length > 0 ? (
                <ul className="events__list">
                    {todays_events.map((item, index) => (
                        <li className="event__item event__item--today" key={index}>
                            <div className="event__date">
                                <span className="event__day">{item.event_day}</span>
                                <span className="event__month">{item.event_month}</span>
                            </div>
                            <div className="event__content">
                                <a href={item.link} className="event__title">{item.event_title}</a>
                                {item.event_campus !== '' &&
                                <div className="event__location">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20">
                                        <g fill="#3E3E3E" fillRule="nonzero">
                                            <path d="M5.896 18.904C5.656 18.504 0 9.736 0 6.4a6.4 6.4 0 1 1 12.8 0c0 3.336-5.656 12.104-5.896 12.504a.608.608 0 0 1-.496.296.592.592 0 0 1-.512-.296zm.512-17.712A5.216 5.216 0 0 0 1.2 6.4c0 2.264 3.384 7.832 5.208 11.008 1.824-3.2 5.216-8.744 5.216-11.008a5.216 5.216 0 0 0-5.216-5.208z"/>
                                            <path d="M6.408 10.008a3.608 3.608 0 1 1 0-7.216 3.608 3.608 0 0 1 0 7.216zm0-6.016a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z"/>
                                        </g>
                                    </svg>
                                    {item.campus_map_url ? 
                                        <>
                                        <a className="event__location-link" href={item.campus_map_url}>
                                            <span className="event__location-name">{item.event_campus}</span>
                                        </a>
                                        </> 
                                        : 
                                        <>
                                        <span className="event__location-name">{item.event_campus}</span>
                                        </>
                                    }
                                </div>
                                }
                            </div>
                        </li>
                    ))}
                </ul>
                ) : (
                    <p>{no_data_message}</p>
                )}


                <span className="schedule__heading">Upcoming</span>
                {current_upcoming_events.length > 0 ? (
                <>
                <div className="events__upcoming">
                <ul className="events__list">
                    {current_upcoming_events.map((item, index) => (
                        <li className="event__item" key={index}>
                            <div className="event__date">
                                <span className="event__day">{item.event_day}</span>
                                <span className="event__month">{item.event_month}</span>
                            </div>
                            <div className="event__content">
                                <a href={item.link} className="event__title">{item.event_title}</a>
                                {item.event_campus !== '' &&
                                <div className="event__location">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20">
                                        <g fill="#3E3E3E" fillRule="nonzero">
                                            <path d="M5.896 18.904C5.656 18.504 0 9.736 0 6.4a6.4 6.4 0 1 1 12.8 0c0 3.336-5.656 12.104-5.896 12.504a.608.608 0 0 1-.496.296.592.592 0 0 1-.512-.296zm.512-17.712A5.216 5.216 0 0 0 1.2 6.4c0 2.264 3.384 7.832 5.208 11.008 1.824-3.2 5.216-8.744 5.216-11.008a5.216 5.216 0 0 0-5.216-5.208z"/>
                                            <path d="M6.408 10.008a3.608 3.608 0 1 1 0-7.216 3.608 3.608 0 0 1 0 7.216zm0-6.016a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z"/>
                                        </g>
                                    </svg>
                                    {item.campus_map_url ? 
                                        <>
                                        <a className="event__location-link" href={item.campus_map_url}>
                                            <span className="event__location-name">{item.event_campus}</span>
                                        </a>
                                        </> 
                                        : 
                                        <>
                                        <span className="event__location-name">{item.event_campus}</span>
                                        </>
                                    }
                                    
                                </div>
                                }
                            </div>
                        </li>
                    ))}
                </ul>
                </div>
                
                {use_pagination &&
                    <div className="pagination__wrapper">
                        {current_page == 1 ? (
                            <span href="#" className="btn--prev"></span>
                        ): (
                            <a href="#" className="btn--prev" title="Previous" onClick={this_component.previousPaginationClick}></a>
                        )}
                        <div className="pagination__summary">Page <span className="pagination__current">{current_page}</span> of <span className="pagination__total">{total_pages}</span>
                        </div>
                        {current_page == total_pages ? (
                            <span href="#" className="btn--next" title=""></span>
                        ): (
                            <a href="#" className="btn--next" title="Next" onClick={this_component.nextPaginationClick}></a>
                        )}
                    </div>
                }
                </>

                ) : (
                    <p>{no_data_message}</p>
                )}

            </div>
        );
    }

};

UniversityEvents.contextType = PortalContext;
